// What of an interest history row is paid and acknowledged, as positive
// amounts to show. The rest is running, which is left implicit. A part that
// is the whole row is named without its amount.
export const interestStatus = (lang, row) => {
    const parts = [
        { label: lang.economy.voucherInfoIPaid, amount: -(row.paid ?? 0) },
        {
            label: lang.economy.voucherInfoIAcknowledged,
            amount: -(row.acknowledged ?? 0),
        },
    ].filter((part) => part.amount !== 0);
    if (parts.length === 1 && parts[0].amount === -row.amount) {
        return [{ label: parts[0].label, amount: null }];
    }
    return parts;
};
// Rows without a status, as from engine 1, add nothing paid or acknowledged
export const sumInterestStatus = (sum, row) => ({
    amount: sum.amount + row.amount,
    paid: (sum.paid ?? 0) + (row.paid ?? 0),
    acknowledged: (sum.acknowledged ?? 0) + (row.acknowledged ?? 0),
});
//# sourceMappingURL=interest-status.js.map